export default "__VITE_ASSET__BARO2mJZ__"